module.exports = __webpack_public_path__ + "static/media/recently-added-nuggets.0834a92d.svg";